<div class="row detail-property">
  <div class="col form-group">
    <label for="id">{{ caption }}</label>
    <div [id]="id">
      {{ value }}
    </div>
  </div>
</div>
